import React, { useCallback } from 'react';
import type { ScrollView } from 'react-native';

interface ScrollToParams {
  x?: number;
  y?: number;
  animated?: boolean;
}

export function useScroll(scrollRef: React.RefObject<ScrollView>) {
  const scrollTo = useCallback(
    ({ x = 0, y = 0, animated = true }: ScrollToParams) => {
      if (!scrollRef.current) {
        return;
      }

      const timerId = setTimeout(() => {
        scrollRef.current?.scrollTo({ x, y, animated });
        window?.scrollTo?.({
          top: y,
          left: x,
          behavior: animated ? 'smooth' : 'auto',
        });
      }, 0);

      return () => {
        clearTimeout(timerId);
      };
    },
    [scrollRef]
  );

  return { scrollTo };
}
